const keepCacheWhileRefetchingFor20s = 20 * 1000;

export const STALE_TIME_5MIN = 5 * 60 * 1000;

export const STALE_TIME_1HR = 1 * 60 * 60 * 1000;

export const CACHE_TIME_1HR = STALE_TIME_1HR + keepCacheWhileRefetchingFor20s;

export const STALE_TIME_2HR = 2 * STALE_TIME_1HR;

export const CACHE_TIME_2HR = STALE_TIME_2HR + keepCacheWhileRefetchingFor20s;

export const CACHE_TIME_20MIN = 20 * 60 * 1000 + keepCacheWhileRefetchingFor20s
